import { Center, createIcon, HStack, Text } from '@chakra-ui/react';

interface SelectionModalHeaderProps {
  title: string;
  IconComponent: ReturnType<typeof createIcon>;
}

function ModalHeader({ title, IconComponent }: SelectionModalHeaderProps) {
  return (
    <HStack>
      <Center
        bgColor='primary.background'
        width='32px'
        height='32px'
        borderRadius='4px'
      >
        <IconComponent
          color='primary.text'
          stroke='primary.text'
          boxSize='20px'
          fill='transparent'
        />
      </Center>
      <Text fontWeight='semibold' fontSize='lg' lineHeight='24px'>
        {title}
      </Text>
    </HStack>
  );
}

export default ModalHeader;
